import React from 'react';
import CryptoIcon from '../CryptoIcon/CryptoIcon';
import './LPIcon.scss';

interface LPIconProps {
    token0: string;
    token1: string;
    size?: number;
}

const LPIcon: React.FC<LPIconProps> = ({ token0, token1, size = 24 }) => {
    const iconSize = size * 0.7;
    const containerWidth = size * 1.2;

    return (
        <div className="LPIcon" style={{ width: containerWidth, height: size }}>
            <div className="LPIcon__token0">
                <CryptoIcon ticker={token0} size={iconSize} />
            </div>
            <div className="LPIcon__token1">
                <CryptoIcon ticker={token1} size={iconSize} />
            </div>
        </div>
    );
};

export default LPIcon;
